import React, { useCallback, useRef, useState } from 'react';
import { usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetCollectorsMaterialsQuery } from './graphql';
import { buildWhereFromFilterValues, Filters } from './collectors-materials-filters';
import { CollectorNomoiDataGrid } from './collector-materials-grid';
import { useApolloClient } from '@apollo/client';
import { getRouteByName } from 'app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { observer } from 'mobx-react-lite';

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const CollectorsMaterialsGridPage = observer(
  ({ collectorId, isGridInForm = false }: { collectorId?: number; isGridInForm?: boolean }) => {
    const { appStore } = useRootStore();
    const { handleGraphqlError } = useHandleError('CollectorsMaterialsGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    const { canView, canAddNew, canEdit, canDelete } = useUserLocationPermissions();
    const persistedValues = isGridInForm ? { collectorId } : {};
    const handleAddNew = () => {};
    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'material.name ASC';
    const query = usePaginatedQueryV8(
      gqlGetCollectorsMaterialsQuery,
      buildWhereFromFilterValues,
      location.state?.order ?? initOrderBy,
      appStore,
      true,
      { collectorId: collectorId, isActive: true },
      !isGridInForm, // History Replace
      !isGridInForm ? undefined : 'nomoi_grid',
      persistedValues,
    );
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    const client = useApolloClient();

    const canCreateNew = true;
    const handleCreateNew = useCallback(() => {
      history.push({
        pathname: generatePath(getRouteByName('CollectorNomos'), { id: -1 }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    }, [history, location.pathname, location.state]);

    const gridRef = useRef();

    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <Card className="shadow">
          <Card.Body className="nopadding">
            {/* Φίλτρα */}
            <Filters
              onChange={filtersChanged}
              initialValues={queryState?.filterValues ?? {}}
              isGridInForm={isGridInForm}
              refetch={refetch}
            />
            {/* Grid */}
            <CollectorNomoiDataGrid
              collectorId={collectorId}
              ref={gridRef}
              loading={loading}
              data={data}
              refetch={refetch}
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              initOrderBy={queryParams?.order ?? initOrderBy}
              onOrderChange={(orderBy) => {
                const newQueryParams = { ...queryParams, order: orderBy };
                setQueryParams(newQueryParams);
                if (!isGridInForm) {
                  history.replace({
                    pathname: location.pathname,
                    state: {
                      ...location.state,
                      order: orderBy,
                    },
                  });
                }
              }}
              selected={selected}
              setSelected={setSelected}
              isGridInForm={isGridInForm}
            />
          </Card.Body>
        </Card>
      );
    }
  },
);

